// Lightweight console limiter: truncates multi-line console output to reduce noise
// Enabled only when the app chooses to require this module (e.g. when log level is 'info').
(function installConsoleLimiter({
  maxLines = (typeof window !== 'undefined' && window.__ENV && Number(window.__ENV.REACT_APP_LOG_MAX_LINES)) || 3,
} = {}) {
  if (typeof window === 'undefined' || !window.console) return;

  const orig = {
    log: console.log.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
  };

  function safeStringify(value) {
    const seen = new WeakSet();
    try {
      return JSON.stringify(value, (k, v) => {
        if (v && typeof v === 'object') {
          if (seen.has(v)) return '[Circular]';
          seen.add(v);
        }
        return v;
      }, 2);
    } catch (e) {
      try { return String(value); } catch (__) { return '[Unserializable]'; }
    }
  }

  function argsToString(args) {
    return args.map(a => {
      if (typeof a === 'string') return a;
      return safeStringify(a);
    }).join(' ');
  }

  function truncateLines(s) {
    if (!s) return s;
    const lines = String(s).split(/\r?\n/);
    if (lines.length <= maxLines) return s;
    const kept = lines.slice(0, maxLines);
    const omitted = lines.length - maxLines;
    return `${kept.join('\n')}\n... (${omitted} more lines truncated)`;
  }

  ['log', 'info', 'warn', 'error'].forEach(level => {
    console[level] = function (...args) {
      try {
        const str = argsToString(args);
        const out = truncateLines(str);
        orig[level](out);
      } catch (e) {
        // fallback to original to avoid breaking console
        orig[level](...args);
      }
    };
  });

  // keep a way to restore if needed
  window.__restoreConsoleLimiter = () => {
    Object.keys(orig).forEach(k => { console[k] = orig[k]; });
    delete window.__restoreConsoleLimiter;
  };
}());

export default null;
